{
  "chat": {
    "title": "Chat",
    "empty": "Ainda não há conversas",
    "loadError": "Não foi possível carregar esta conversa",
    "messagePlaceholder": "Mensagem",
    "typing": "{{name}} está a escrever…",
    "typingTwo": "{{a}} e {{b}} estão a escrever…",
    "typingMany": "Várias pessoas estão a escrever…",
    "online": "Online",
    "offline": "Offline",
    "unread": "Não lida",
    "startDm": "Enviar mensagem a {{name}}",
    "members": "Membros",
    "mute": "Silenciar esta conversa",
    "unmute": "Reativar o som desta conversa",
    "muted": "Silenciada"
  },
  "login": {
    "title": "Bem-vindo de volta!",
    "description": "Introduza o seu endereço de email e enviar-lhe-emos um código para iniciar sessão.",
    "input": {
      "label": "Endereço de email",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Solicitar código",
      "loading": "A enviar código..."
    }
  },
  "verify": {
    "title": "Introduzir código",
    "description": "Introduza o código que lhe enviámos por email para {{email}}.",
    "input": {
      "label": "Código de verificação",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Verificar código",
      "loading": "A verificar código..."
    },
    "buttonAbort": {
      "label": "Cancelar"
    },
    "buttonResend": {
      "label": "Reenviar código"
    },
    "error": {
      "Invalid or expired OTP.": "O código expirou ou é inválido.",
      "invalidOtp": "O código expirou ou é inválido."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Terminar sessão",
      "confirmTitle": "Terminar sessão",
      "confirmMessage": "Tem a certeza de que pretende terminar sessão?",
      "error": "Falha ao terminar sessão. Tente novamente."
    }
  },
  "errors": {
    "types": {
      "authentication": "Erro de autenticação",
      "network": "Problema de ligação",
      "generic": "Algo correu mal"
    },
    "messages": {
      "sessionExpired": "A sua sessão expirou. Inicie sessão novamente.",
      "networkError": "Verifique a sua ligação à internet e tente novamente.",
      "genericError": "Ocorreu um erro inesperado. Pode tentar atualizar a página ou terminar sessão.",
      "noOrg": "Nenhuma organização encontrada..."
    },
    "technical": {
      "title": "Detalhes técnicos:",
      "retryAttempts": "Tentativas: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Tentar novamente",
      "loginAgain": "Iniciar sessão novamente",
      "logout": "Terminar sessão",
      "moreOptions": "Mais opções",
      "chooseAction": "Escolha uma ação:",
      "refreshApp": "Atualizar aplicação",
      "debugData": "Dados de depuração",
      "clearCacheRetry": "Limpar cache e tentar novamente"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "A carregar...",
    "cancel": "Cancelar",
    "confirm": "Confirmar",
    "error": "Erro",
    "success": "Sucesso",
    "time": {
      "dayAgo": "há 1 dia",
      "daysAgo": "há {{count}} dias",
      "weekAgo": "há 1 semana",
      "weeksAgo": "há {{count}} semanas",
      "monthsAgo": "há {{count}} meses",
      "secondsAbbr": "s"
    },
    "profile": "Perfil"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organização não encontrada"
    },
    "quickActions": {
      "media": {
        "title": "Todos os media",
        "subtitle": "Explorar biblioteca"
      },
      "achievements": {
        "title": "Conquistas",
        "subtitle": "Ver progresso"
      },
      "profile": {
        "title": "Cartão de membro",
        "subtitle": "Os seus dados"
      },
      "membership": {
        "title": "Subscrição",
        "subtitle": "Ver plano"
      },
      "offers": {
        "title": "Ofertas",
        "subtitle": "Explorar disponíveis"
      },
      "invite": {
        "title": "Convidar membros",
        "subtitle": "Criar código QR"
      }
    },
    "sections": {
      "featuredVideos": "Vídeos em destaque",
      "lastViewed": "Vistos recentemente",
      "bookmarkedVideos": "Elementos guardados",
      "recentAchievements": "Conquistas recentes",
      "viewAllAction": "Ver tudo"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Configuração de pagamento necessária",
      "subtitle": "A sua subscrição foi transferida para esta organização. Para continuar, configure o seu pagamento com um dos métodos de pagamento disponíveis.",
      "paidUntilNote": "O seu período já pago é mantido — não será cobrado antes de {{date}}.",
      "bonusOffer_one": "Configure o seu pagamento até {{date}} e receba {{count}} mês de bónus grátis.",
      "bonusOffer_other": "Configure o seu pagamento até {{date}} e receba {{count}} meses de bónus grátis.",
      "openDashboard": "Configurar o pagamento no painel web",
      "openDashboardHint": "Por motivos de segurança, a configuração do pagamento é feita no seu navegador. Iniciará sessão automaticamente.",
      "checkAgain": "Concluí o pagamento",
      "error": "Não foi possível iniciar a configuração do pagamento. Tente novamente."
    },
    "codeOfConduct": {
      "heading": "Código de conduta",
      "subtitle": "Leia o texto seguinte e aceite-o para continuar a utilizar esta organização.",
      "acceptLabel": "Li e aceito «{{title}}».",
      "accept": "Aceitar",
      "acceptError": "Não foi possível guardar o seu consentimento. Tente novamente.",
      "loadError": "Não foi possível carregar o texto.",
      "retry": "Tentar novamente",
      "newVersion": "Aplica-se agora uma nova versão. Leia-a e aceite-a."
    },
    "title": "Subscrição",
    "status": {
      "active": "Ativa",
      "inactive": "Inativa"
    },
    "period": {
      "monthly": "Mensal",
      "yearly": "Anual"
    },
    "pricing": {
      "per": {
        "monthly": "por mês",
        "yearly": "por ano"
      }
    },
    "sections": {
      "planDetails": "Detalhes",
      "organization": "Organização"
    },
    "labels": {
      "billingPeriod": "Período de faturação",
      "memberSince": "Membro desde",
      "validUntil": "Válido até",
      "cancelled": "Subscrição cancelada"
    },
    "organization": {
      "memberDescription": "É membro desta organização"
    },
    "management": {
      "title": "Gerir a sua subscrição",
      "description": "Para efetuar alterações à sua subscrição, utilize a WebApp OctaHub ou contacte diretamente {{organizationName}}."
    },
    "dashboard": {
      "title": "Abrir painel",
      "subtitle": "Gerir a sua subscrição e definições",
      "openError": "Não foi possível abrir o painel. Tente novamente."
    }
  },
  "media": {
    "download": {
      "button": "Transferir",
      "available": "Disponível offline"
    },
    "screens": {
      "bookmarks": "Vídeos guardados",
      "lastViewed": "Vídeos vistos recentemente",
      "library": "Media"
    },
    "bookmark": {
      "save": "Guardar",
      "saved": "Guardado",
      "bookmarkLabel": "Marcador",
      "bookmarkedLabel": "Guardado"
    },
    "folder": {
      "itemCount_one": "{{count}} elemento",
      "itemCount_other": "{{count}} elementos",
      "folderDescription": "Pasta com {{count}} elementos"
    },
    "sharedFolders": {
      "upload": "Carregar",
      "newFolder": "Nova pasta",
      "folderNamePlaceholder": "Nome da pasta...",
      "uploading": "A carregar...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "Ficheiro carregado com sucesso",
      "uploadError": "Carregamento falhou",
      "uploadErrorMessage": "Ocorreu um erro durante o carregamento. Tente novamente.",
      "uploadSubtitle": "Carregar um ficheiro para esta pasta",
      "newFolderSubtitle": "Criar uma nova subpasta"
    },
    "navigation": {
      "previous": "Anterior",
      "next": "Seguinte"
    },
    "relatedVideos": "Conteúdo relacionado",
    "delete": {
      "button": "Eliminar",
      "confirmTitle": "Eliminar media",
      "confirmMessage": "Tem a certeza de que pretende eliminar este elemento? Esta ação não pode ser anulada.",
      "success": "Media eliminado com sucesso",
      "error": "Falha ao eliminar",
      "errorMessage": "Não foi possível eliminar este media. Tente novamente.",
      "errorInUse": "Este media é utilizado em uma ou mais ofertas e não pode ser eliminado."
    }
  },
  "achievements": {
    "title": "Conquistas",
    "subtitle": "As suas conquistas obtidas",
    "count_zero": "Nenhuma conquista obtida",
    "count_one": "{{count}} conquista obtida",
    "count_other": "{{count}} conquistas obtidas",
    "earned": "Obtido {{time}}",
    "emptyState": {
      "title": "Sem conquistas ainda",
      "description": "Complete cursos e atividades para obter a sua primeira conquista!"
    }
  },
  "noOrg": {
    "title": "Nenhuma organização encontrada",
    "description": "Ainda não tem acesso a nenhuma organização. Contacte o seu administrador para obter acesso ou tente novamente mais tarde.",
    "actions": {
      "title": "O que pode fazer:",
      "contactAdmin": "Contactar o administrador da sua organização",
      "askInvitation": "Solicitar um convite",
      "checkAccount": "Verificar se está a utilizar a conta correta",
      "tryRelogin": "Tentar terminar sessão e iniciar novamente"
    }
  },
  "offers": {
    "title": "Ofertas",
    "detailsTitle": "Detalhes da oferta",
    "notFound": "Oferta não encontrada",
    "notFoundMessage": "Esta oferta não foi encontrada",
    "noOffers": "Sem ofertas disponíveis de momento",
    "purchased": "Comprado",
    "free": "Gratuito",
    "purchaseWebOnly": "Compra apenas na web-app",
    "claimOffer": "Resgatar oferta",
    "purchase": "Comprar",
    "purchasedBadge": "✓ Já possui esta oferta",
    "youOwnThis": "Tem acesso a todo o conteúdo desta oferta",
    "missingAchievements": "⚠️ Não possui as conquistas necessárias para esta oferta. Ainda falta: {{missing}}",
    "mobileNotAvailable": "⚠️ As compras não estão disponíveis na aplicação móvel",
    "mobileNotAvailableSubtext": "Visite o nosso website para comprar esta oferta",
    "price": "Preço:",
    "includedContent": "Conteúdo incluído",
    "includedAchievements": "Conquistas incluídas",
    "videoCount_one": "{{count}} vídeo",
    "videoCount_other": "{{count}} vídeos",
    "audioCount_one": "{{count}} áudio",
    "audioCount_other": "{{count}} áudios",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDFs",
    "documentCount_one": "{{count}} documento",
    "documentCount_other": "{{count}} documentos",
    "imageCount_one": "{{count}} imagem",
    "imageCount_other": "{{count}} imagens",
    "achievementCount_one": "{{count}} conquista",
    "achievementCount_other": "{{count}} conquistas",
    "paymentDenied": {
      "title": "Pagamento indisponível",
      "description": "Esta oferta não está disponível para compra na sua região"
    },
    "pricing": {
      "netAmount": "Valor líquido"
    },
    "errors": {
      "general": "Erro",
      "purchaseFailed": "Falha ao processar a compra",
      "webOnly": "As compras estão disponíveis apenas na versão web"
    },
    "success": {
      "claimed": "Oferta resgatada com sucesso!"
    },
    "paymentProviders": {
      "selectTitle": "Selecionar método de pagamento",
      "selectSubtitle": "Escolha como pretende pagar",
      "stripe": {
        "name": "Stripe",
        "description": "Cartão de crédito, cartão de débito, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "Saldo PayPal, cartão de crédito, conta bancária"
      }
    },
    "payment": {
      "processing": "A processar o seu pagamento...",
      "success": {
        "title": "Pagamento efetuado com sucesso!",
        "message": "A sua compra foi concluída com sucesso. Tem agora acesso ao conteúdo.",
        "viewOffer": "Ver oferta",
        "backToOffers": "Voltar às ofertas"
      },
      "pending": {
        "title": "Pagamento em processamento",
        "message": "O seu pagamento ainda está a ser processado. Pode demorar alguns instantes...",
        "checkStatus": "Verificar estado"
      },
      "failed": {
        "title": "Pagamento falhado",
        "message": "O seu pagamento não pôde ser concluído. Tente novamente.",
        "tryAgain": "Tentar novamente"
      }
    }
  },
  "orgSelection": {
    "title": "Selecionar organização",
    "subtitle": "Escolha uma organização para continuar",
    "switchOrg": "Mudar de organização",
    "switchOrgSubtitle": "Mudar para outra organização",
    "currentOrg": "Atual"
  },
  "profile": {
    "myPurchases": "As minhas compras",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Idioma",
      "subtitle": "Selecione o seu idioma preferido",
      "systemDefault": "Predefinição do sistema"
    },
    "notifications": {
      "title": "Notificações",
      "subtitle": "Escolha aquilo sobre o qual quer ser notificado",
      "chat": "Mensagens do chat",
      "chatHint": "Receba notificações de novas mensagens nas suas conversas",
      "seeAll": "Ver todas as notificações",
      "permissionDenied": "As notificações desta aplicação estão desativadas nas definições do seu dispositivo."
    }
  },
  "openWebApp": "Abrir Web App",
  "openWebAppSubtext": "Gerir a sua conta, compras e mais em {{url}}",
  "openWebAppError": "Não foi possível abrir a web app. Tente novamente.",
  "invite": {
    "title": "Convidar membros",
    "selectPlan": "Selecionar um plano de adesão",
    "selectGroup": "Selecionar um grupo",
    "generating": "A gerar...",
    "scanToJoin": "Digitalize este código QR para aderir",
    "createAnother": "Criar outro",
    "error": {
      "createFailed": "Não foi possível criar o convite. Tente novamente.",
      "noPlans": "Nenhum plano de adesão disponível."
    }
  },
  "notifications": {
    "title": "Notificações",
    "empty": "Ainda não há notificações",
    "markAllRead": "Marcar todas como lidas",
    "unread": "Não lida",
    "loadError": "Não foi possível carregar as notificações",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Nova mensagem"
    }
  }
}
